import type { Key } from '@framework/domain';

export abstract class Model<K extends Key> {
  abstract key: K;
}
